import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './link.module.css';

export interface LinkContainerProps {
  text: string;
  link: string;
  isExternal?: boolean;
}

export const LinkContainer: FC<LinkContainerProps> = ({
  text,
  link,
  isExternal,
}) => {
  const history = useHistory();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (isExternal) {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else {
      history.push(link);
    }
  };

  return (
    <a href={link} onClick={handleClick} className={styles.link} title={text}>
      {text}
    </a>
  );
};
